import type { LocationDescriptor } from 'history';

export interface JoinBannerData {
  shelterLink: LocationDescriptor;
  vetLink: LocationDescriptor;
  groomerLink: LocationDescriptor;
  breederLink: LocationDescriptor;
  buyerLink: LocationDescriptor;
  educatorLink: LocationDescriptor;
}

export interface JoinBannerProps extends JoinBannerData {}
